import iziToast from "izitoast";
import Vue from "vue";
import VueNotifications from "vue-notifications";

import "../node_modules/izitoast/dist/css/iziToast.min.css";

function launchNotification({ params, ...argMap }) {
  if (typeof params === "string") {
    params = { message: params };
  }

  const notificationsParams = Object.assign(
    {},
    {
      ...argMap,
    },
    params
  );

  toast(notificationsParams);
}

/**
 * iziToast docs: http://izitoast.marcelodolce.com/
 * Vue Notifications: https://se-panfilov.github.io/vue-notifications/docs/html/usage.html
 */
function toast(params) {
  // iziToast and Vue-notifications differ on their warn/warning data contract
  if (params.type === VueNotifications.types.warn) {
    params.type = "warning";
  }

  if (!params.position) params.position = "topRight";

  return iziToast[params.type](params);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

Vue.prototype.$notifyError = params => {
  launchNotification({
    icon: "fas fa-exclamation-triangle",
    params,
    title: "Error",
    type: "error",
  });
};

Vue.prototype.$notifyInfo = params => {
  launchNotification({
    icon: "fas fa-info-circle",
    params,
    title: null,
    type: "info",
  });
};

Vue.prototype.$notifySuccess = params => {
  launchNotification({
    icon: "fas fa-check-circle",
    params,
    title: "Success",
    type: "success",
  });
};

Vue.prototype.$notifyWarn = params => {
  launchNotification({
    icon: "fas fa-exclamation-triangle",
    params,
    title: "Warning",
    type: "warn",
  });
};

Vue.use(VueNotifications, options);
